import React, { useState } from 'react';

import './index.scss';
import { useTextInsert } from '../../../LeftWorkArea/LeftWorkAddText/useTextInsert';

export interface IAddText{
}

export const AddText = (props: IAddText) => {

    const[text, setText] = useState(undefined as undefined|string)

    const { handleAddText } = useTextInsert();

    return (
        <div className="addTextContainerDiv">
            <div className="addTextInptContainer">
                <form>
                    <textarea
                        className="addTextArea"
                        typeof="text"
                        placeholder="Enter text"
                        onChange={({target}) => {
                            setText(target.value)
                        }}
                    ></textarea>
                    <button onClick={() => {
                        handleAddText(text)
                    }} className="addTextBtn">
                        add text
                    </button>
                </form>
            </div>
        </div>
    )
}